import _ from 'lodash';

import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function UserPreferencesAutoEmailsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserPreferencesAutoEmails', {
		url: '/preferences/auto_emails',
		controllerAs: 'vm',
		controller: UserPreferencesAutoEmailsCtrl,
		templateUrl: '/ng/hub/User/Preferences/AutoEmails/UserPreferencesAutoEmailsCtrl.html?' + window.BUILD,
		permission: ['login'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/User/Preferences/AutoEmails/UserPreferencesAutoEmailsCtrl.css'),
			$title: () => 'Automated Alerts',
			icons: () => AssetManager.css('/assets/fonts/Linearicons/style.css'),
		},
	});
}

export class UserPreferencesAutoEmailsCtrl {
	constructor(Api, Identity, $timeout, modal, notifications, Cfg) {
		'ngInject';
		this.Api = Api;
		this.modal = modal;
		this.filters = {};
		this.$timeout = $timeout;
		this.notifications = notifications;
		this.Cfg = Cfg;

		this.currentClientId = Identity.currentClient().id;
		this.userId = Identity.user().id;
		this.columns = [
			{ field: 'subject', label: 'Notification name (subject line)' },
			{ field: 'freqLabel', label: 'Frequency' },
		];
		this.userAutoEmails = {
			columns: [
				{ field: 'subject', label: 'Name' },
				{ field: 'createdBy', label: 'Creator' },
				{ field: 'freqLabel', label: 'Frequency' },
			],
			actions: [
				{ label: 'Delete', icon: 'cancel', callback: this.deleteAutoEmail.bind(this) },
				{ label: 'Edit', icon: 'pencil', callback: this.editAutoEmail.bind(this) },
				{ label: 'Notification history', icon: 'graph', callback: this.goToHistory },
			],
		};
		this.clientAutoEmails = {
			columns: [
				{
					field: 'isSubscribed',
					label: 'Subscribe',
					callback: this.toggleSubscriptionForUser.bind(this),
				},
				{ field: 'subject', label: 'Name' },
				{ field: 'createdBy', label: 'Creator' },
				{ field: 'freqLabel', label: 'Frequency' },
			],
		};
	}

	deleteAutoEmail(autoEmail) {
		this.modal
			.confirm({
				text: _.escape(autoEmail.subject),
				heading: 'Delete Notification?',
			})
			.then(
				() => {
					this.Api.delete(`/auto_emails/${autoEmail.id}`).then(() => {
						window.location.reload();
					});
				},
				error => {
					return null;
				}
			);
	}

	editAutoEmail(autoEmail) {
		const displayKnowledgebaseLink = Boolean(Number(this.Cfg.read('KnowledgebaseLink.Display')));
		const knowledgebaseLinkUrl = this.Cfg.read('KnowledgebaseLink.AutomatedAlerts.Modal.CreateAutomatedAlert');

		// IMPORTANT: The "title" sent here must exactly the title set in AutoEmailCtrl.save()
		const title = (autoEmail ? 'Edit' : 'Create') + ' an Automated Alert';
		this.modal
			.state('hub.loggedin.AutoEmail', {
				heading: title,
				displayKnowledgebaseLink,
				knowledgebaseLinkUrl,
				params: {},
				injections: { Rec: autoEmail },
				width: 850,
				height: 'full',
			})
			.then(
				message => {
					if (message) {
						this.notifications.showSuccess(message);
						window.location.reload();
					}
				},
				error => {
					if (error && error !== 'X') {
						this.notifications.showError(error);
					}
				}
			);
	}

	transformer(items) {
		const freqLookup = {
			immediate: 'Immediately',
			weekdays: 'Weekdays',
			every: 'Every day',
			mon: 'Mondays',
			tue: 'Tuesdays',
			wed: 'Wednesdays',
			thu: 'Thursdays',
			fri: 'Fridays',
			mwf: 'M/W/F',
			tt: 'Tu/Th',
		};

		items.data.forEach(autoEmail => {
			// By default, every person is initially considered to be not subscribed to each auto-email.
			autoEmail.isSubscribed = false;

			// Figure out if the current user is currently subscribed to the target auto-email.
			for (const email in autoEmail.subscribers) {
				if (autoEmail.subscribers[email].id === autoEmail.current_user_id) {
					autoEmail.isSubscribed = true;
					break;
				}
			}

			autoEmail.freqLabel = freqLookup[autoEmail.send_frequency];
			autoEmail.createdBy = autoEmail.created_by.email;
			autoEmail.isPrivate = autoEmail.is_public === '1' ? false : true;
		});

		return items;
	}

	goToHistory(Rec) {
		window.location = '/hub#/auto_emails/' + Rec.id;
	}

	/**
	 * Process the toggle and then reload.
	 * @param subscription
	 */
	toggleSubscriptionForUser(subscription) {
		this.Api.request('patch', `/auto_emails/${subscription.id}/toggle_user_subscription`, {
			user_id: subscription.current_user_id,
		}).then(() => {
			/* Nothing needs to happen here, after all. */
		});
	}
}
